// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//= require tinymce


import "@hotwired/turbo-rails";
import * as ActiveStorage from "@rails/activestorage";
import Rails from "@rails/ujs";
import "channels";
import ReactOnRails from 'react-on-rails';
import './reactTurboCleanup';

Rails.start()
ActiveStorage.start()

document.addEventListener("turbo:before-cache", () => {
  // This tells React on Rails to prepare for a page swap
  // It helps prevent "double mounting" or components vanishing on 'Back' button
  ReactOnRails.reactOnRailsPageLoaded(); 
  // Que el snapshot cacheado nunca guarde el scroll bloqueado por el drawer
  document.documentElement.classList.remove('--drawer-open');
});

document.addEventListener("turbo:load", () => {
  // This forces React on Rails to scan the DOM for any <%= react_component %> 
  // tags and mount them immediately.
  ReactOnRails.reactOnRailsPageLoaded();
});

// Add bootstrap
import "bootstrap";

// Add trix / Action Text
import "./actiontext";

// Chartkick
// import "chartkick/chart"
import "chartkick"